import { media } from '../../../../utils/styles'
import styled from 'styled-components'

export const Banner = styled.section`
  display: flex;
  padding: var(--spacing-size-sm) 27.5%;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-size-2xs);
  background-color: var(--color-brand-500);

  & > svg {
    max-width: 170px;
    min-width: 114px;
  }

  ${media.desktop`
    padding: var(--spacing-size-sm) 25%;
  `}

  ${media.laptop`
    padding: var(--spacing-size-sm) 20%;
  `}

  ${media.tablet`
    gap: var(--spacing-size-2xs);
  `}

  ${media.mobile`
    & > svg {
      display: none;
    }
  `}
`

export const Greetings = styled.div`
  gap: var(--spacing-size-4xs);
  display: flex;
  flex-direction: column;
`

export const GreetingsTitle = styled.h1`
  color: var(--color-contrast-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-4xl);
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  margin: 0px;
  padding: 0px;
  width: fit-content;
  line-height: var(--line-height-xs);

  ${media.desktop`
    font-size: var(--font-size-3xl);
  `}
`

export const GreetingsSubtitle = styled.p`
  color: var(--color-contrast-white);
  margin: 0px;
  padding: 0px;
  width: 100%;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  overflow-wrap: break-word;
  font-size: var(--font-size-default);
  line-height: var(--line-height-md);
`
